import type { OtpDeliveryMethod } from '@/types/auth.types';
import { RadioInput } from '@/components/ui/RadioInput';

interface DeliveryMethodSelectorProps {
  value: OtpDeliveryMethod | null;
  onChange: (method: OtpDeliveryMethod) => void;
  disabled?: boolean;
  title?: string;
  emailLabel?: string;
  mobileLabel?: string;
}

export const DeliveryMethodSelector = ({
  value,
  onChange,
  disabled = false,
  title,
  emailLabel = 'Email',
  mobileLabel = 'Mobile',
}: DeliveryMethodSelectorProps) => {
  const handleChange = (method: string) => {
    onChange(method as OtpDeliveryMethod);
  };

  return (
    <div className="mb-3">
      {title && <label className="nova-delivery-title">{title}</label>}
      <div className="nova-delivery-options">
        <RadioInput
          name="deliveryMethod"
          value="EMAIL"
          checked={value === 'EMAIL'}
          label={emailLabel}
          onChange={handleChange}
          disabled={disabled}
        />
        <RadioInput
          name="deliveryMethod"
          value="SMS"
          checked={value === 'SMS'}
          label={mobileLabel}
          onChange={handleChange}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default DeliveryMethodSelector;
